<template>
  <div class="h-full flex flex-col overflow-hidden">
    <!-- Header -->
    <threads-nav show-back>
      <template #center> 会员中心 </template>
    </threads-nav>

    <!-- Main Content -->

    <div v-if="loading" class="flex-1 flex justify-center items-center">
      <div class="loading loading-ring loading-lg"></div>
    </div>
    <main v-else class="flex-1 overflow-hidden flex flex-col w-full">
      <div class="flex justify-between w-full bg-base-200 px-4 py-2">
        <div class="flex flex-col gap-2 w-full">
          <div class="flex justify-between">
            <div class="font-bold text-lg">{{ mateStore.userMate.name }}</div>

            <!-- <button
              class="btn btn-xs btn-primary gap-1"
              @click="clickImmediateRenewal"
            >
              {{ $t("User.immediateRenewal") }}
              <CrystalIcon />
              {{ subscription?.plan.price }}
            </button> -->
          </div>
          <div
            class="flex w-full items-center justify-between text-base-content/70 text-xs leading-snug gap-1"
          >
            <div
              v-if="userStore.getMemberType !== MemberType.Free"
              :class="[
                'flex items-center gap-1 border rounded-full px-1  text-xs',
                memberRarityMap[userStore.getMemberType],
              ]"
              @click.stop="router.push({ name: 'memberCenter' })"
            >
              会员: {{ $t(`User.memberType.${userStore.getMemberType}`) }}
            </div>
            <div>
              到期时间
              {{
                moment(subscription?.dtCurrentPeriodEnd).format("YYYY-MM-DD")
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex-1 overflow-y-auto p-4">
        <div class="rounded-box">
          <div class="red-dot mb-4 flex justify-between items-center">
            <h2 class="text-base font-semibold">我的权益</h2>
            <div class="flex justify-end">
              <!-- <button
                v-if="!subscription?.dtCancel"
                class="btn btn-xs opacity-60"
                @click="clickCancelSubscription"
              >
                取消订阅
              </button> -->
            </div>
          </div>
          <CrystalMemberBenefits
            v-if="userStore.getMemberType !== MemberType.Free"
            :benefits="
              originMemberData[userStore.getMemberType]?.benefits || []
            "
          />
        </div>
        <div
          class="flex w-full bg-base-200 px-2 py-2 mt-4 rounded gap-2 items-center"
        >
          <div class="badge badge-outline badge-sm">
            {{ $t(`User.billingCycle.${subscription?.plan.billingCycle}`) }}
          </div>

          <div
            class="badge badge-outline badge-sm"
            :class="[subscription?.dtCancel ? 'badge-error' : 'badge-success']"
          >
            {{
              subscription?.dtCancel
                ? $t(`User.memberStatus.canceled`)
                : $t(`User.memberStatus.active`)
            }}
          </div>

          <button
            class="btn btn-xs opacity-80"
            @click="clickCancelSubscription"
            v-if="!subscription?.dtCancel"
          >
            {{ $t(`Buttons.cancelRenewal`) }}
          </button>
          <button
            v-else
            class="btn btn-xs btn-primary"
            @click="clickResumeSubscription"
          >
            {{ $t("Buttons.resumeSubscription") }}
          </button>
          <!-- <div class="flex flex-col gap-2">
            <div class="font-bold">
              {{ $t(`User.memberType.${userStore.getMemberType}`) }}
            </div>
          </div> -->
        </div>

        <div class="divider my-1"></div>
        <template v-if="userStore.getMemberType === MemberType.Basic">
          <h2 class="red-dot text-base font-semibold mt-4 mb-2">会员升级</h2>

          <van-tabs
            v-model:active="currentPlan"
            @change="clickToPlan(currentPlan)"
          >
            <van-tab title="行星构筑师" :name="MemberType.Standard"></van-tab>
            <van-tab title="星系幻想家" :name="MemberType.Premium"></van-tab>
          </van-tabs>

          <div class="flex-1 overflow-y-auto p-4">
            <!-- Pricing Options -->
            <div class="grid grid-cols-3 gap-3 text-center">
              <div
                v-for="(price, index) in currentPlanData.prices"
                :key="index"
                :class="[
                  'card relative bg-base-100 cursor-pointer border-2 ',
                  selectedPrice.id === price.id
                    ? 'border-primary'
                    : 'border-base-200',
                ]"
                @click="clickPlan(price)"
              >
                <div
                  v-if="price.tag"
                  :class="[
                    'badge absolute -top-2 left-1/2 -translate-x-1/2 whitespace-nowrap',
                    price.tag === '最划算'
                      ? 'badge-secondary'
                      : 'badge-primary',
                  ]"
                >
                  {{ price.tag }}
                </div>
                <div class="card-body p-3 pt-5">
                  <h3 class="font-semibold">{{ price.type }}</h3>
                  <p
                    :class="[
                      'text-2xl font-bold my-1',
                      { 'text-primary': selectedPrice.id === price.id },
                    ]"
                  >
                    <span class="text-lg">¥</span>{{ price.price }}
                  </p>
                </div>
              </div>
            </div>

            <!-- <div class="my-4 flex justify-center items-center">
              <div
                class="flex justify-center items-center gap-1 bg-neutral text-neutral-content px-4 py-1 rounded-full"
              >
                会员期间可共计获得 <PowerIcon />
                <span class="text-primary text-base font-bold">
                  {{ fixNumber(currentPlanData.total * month) }}
                </span>
              </div>
            </div> -->
            <!-- Benefits Section -->
            <div class="bg-base-100 rounded-box py-5">
              <h2 class="text-lg font-semibold mb-4 text-content-focus">
                {{ currentPlanData.name }} - 每月会员权益
              </h2>

              <CrystalMemberBenefits :benefits="currentPlanData?.benefits" />
            </div>

            <CrystalPayment
              v-model:selected-payment-method="selectedPaymentMethod"
              v-model:selected-price="selectedPrice"
            />
          </div>
        </template>

        <template v-if="userStore.getMemberType === MemberType.Standard">
          <h2 class="red-dot text-base font-semibold my-4">升级至星际幻想家</h2>

          <!-- Pricing Options -->
          <div class="grid grid-cols-3 gap-3 mb-6 text-center">
            <div
              v-for="(price, index) in plansData[MemberType.Premium].prices"
              :key="index"
              :class="[
                'card relative  cursor-pointer border-2',
                selectedPrice.id === price.id
                  ? 'border-primary'
                  : 'border-base-200',
              ]"
              @click="clickPlan(price)"
            >
              <div
                v-if="price.tag"
                :class="[
                  'badge absolute -top-2 left-1/2 -translate-x-1/2 whitespace-nowrap',
                  price.tag === '最划算' ? 'badge-secondary' : 'badge-primary',
                ]"
              >
                {{ price.tag }}
              </div>
              <div class="card-body p-3 pt-5">
                <h3 class="font-semibold">{{ price.type }}</h3>
                <p
                  :class="[
                    'text-2xl font-bold my-1',
                    { 'text-primary': selectedPrice.id === price.id },
                  ]"
                >
                  <span class="text-lg">¥</span>{{ price.price }}
                </p>
              </div>
            </div>
          </div>

          <!-- Benefits Section -->
          <div class="bg-base-100 rounded-box p-5">
            <h2 class="text-lg font-semibold mb-4 text-content-focus">
              {{ currentPlanData.name }} - 每月会员权益
            </h2>

            <CrystalMemberBenefits :benefits="currentPlanData.benefits" />
          </div>

          <!-- Footer / CTA -->
          <CrystalPayment
            v-model:selected-payment-method="selectedPaymentMethod"
            v-model:selected-price="selectedPrice"
            @pay-finish="initSubscription"
          />
        </template>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useGlobalUser } from "@/stores/globalUser";
import { useRouter } from "vue-router";
import {
  cancelOneMemberSubscription,
  readMemberPlanPage,
  readMemberSubscriptionPage,
  resumeOneMemberSubscription,
} from "@/apis/user";
import { BillingCycle, MemberType, PaymentMethod } from "@/enums/mateEnums";
import moment from "moment-timezone";
import { MemberSubscription } from "@/types/entity";
import { originMemberData, originPlanData } from "./memberData";
import { showConfirmDialog, showSuccessToast } from "vant";
import { useMate } from "@/stores/mate";
import { memberRarityMap } from "@/types/user";

const userStore = useGlobalUser();
const mateStore = useMate();
const router = useRouter();

const plansData = ref(originPlanData);
const loading = ref(true);

// 响应式状态
const currentPlan = ref<MemberType.Standard | MemberType.Premium>(
  MemberType.Premium
);
const selectedPaymentMethod = ref<PaymentMethod>(PaymentMethod.Crystal);
const selectedPrice = ref<{ id: number; price: number; wechatPlanId?: number }>(
  { id: 0, price: 0 }
);

// 计算属性
const currentPlanData = ref(originPlanData[currentPlan.value]);

const clickToPlan = (plan: MemberType.Standard | MemberType.Premium) => {
  currentPlan.value = plan;
  currentPlanData.value = originPlanData[plan];
  selectedPrice.value = currentPlanData.value.prices[0];
};

const clickPlan = (price: {
  id: number;
  price: number;
  billingCycle: BillingCycle;
  wechatPlanId?: number;
}) => {
  selectedPrice.value = price;
};
onMounted(async () => {
  try {
    await Promise.all([initPlanList(), initSubscription()]);
    loading.value = false;
  } catch {
    router.back();
  }
});

const initPlanList = async () => {
  const res = await readMemberPlanPage();
  if (res.page.data.length < 6) return;
  const [
    monthStandard,
    quarterStandard,
    yearStandard,
    monthPremium,
    quarterPremium,
    yearPremium,
    monthBasic,
    quarterBasic,
    yearBasic,
  ] = res.page.data;

  plansData.value[MemberType.Standard].prices = [
    {
      type: "连续包月",
      tag: "超值首选",
      ...monthStandard,
    },
    {
      type: "连续包季",
      tag: "",
      ...quarterStandard,
    },
    {
      type: "连续包年",
      ...yearStandard,
      tag: "最划算",
    },
  ];

  plansData.value[MemberType.Premium].prices = [
    { type: "连续包月", tag: "超值首选", ...monthPremium },
    { type: "连续包季", tag: "", ...quarterPremium },
    { type: "连续包年", tag: "最划算", ...yearPremium },
  ];

  plansData.value[MemberType.Basic].prices = [
    { type: "连续包月", tag: "超值首选", ...monthBasic },
    { type: "连续包季", tag: "", ...quarterBasic },
    { type: "连续包年", tag: "最划算", ...yearBasic },
  ];
  selectedPrice.value = plansData.value[MemberType.Standard].prices[0];

  if (userStore.getMemberType === MemberType.Basic) {
    clickToPlan(MemberType.Standard);
    // clickPlan(plansData.value[MemberType.Standard].prices[0]);
  } else if (userStore.getMemberType === MemberType.Standard) {
    clickToPlan(MemberType.Premium);
    // clickPlan(plansData.value[MemberType.Premium].prices[0]);
  }
};

const subscription = ref<MemberSubscription | null>(null);
const initSubscription = async () => {
  const res = await readMemberSubscriptionPage();
  if (res.page.data.length > 0) {
    subscription.value = res.page.data[0];
  }
};

const clickCancelSubscription = async () => {
  showConfirmDialog({
    title: "取消订阅",
    message: "确定要取消订阅吗？取消订阅之后，您的相关权益会在到期后失效。",
    confirmButtonText: "确定",
    cancelButtonText: "取消",
  }).then(async () => {
    const res = await cancelOneMemberSubscription(subscription.value!.id!);
    if (res.item) {
      subscription.value!.dtCancel = res.item.dtCancel;
      subscription.value!.dtEnd = res.item.dtEnd;
    }
  });
};

const clickResumeSubscription = async () => {
  const res = await resumeOneMemberSubscription(subscription.value!.id!);
  if (res.data.item) {
    subscription.value!.dtCancel = res.data.item.dtCancel;
    subscription.value!.dtEnd = res.data.item.dtEnd;
    showSuccessToast("恭喜您！恢复订阅成功🎉");
  }
};

// const modalStore = useGlobalModal();
// const clickImmediateRenewal = async () => {
//   const memberType = getMemberTypeByPlanId(subscription.value!.planId!);

//   const planData = originPlanData[memberType!];
//   const res = await renewOneMemberSubscription(subscription.value!.id!, {
//     planId: subscription.value!.planId,
//     paymentMethod: selectedPaymentMethod.value,
//   });
//   if (res.data) {
//     subscription.value!.dtCurrentPeriodEnd = res.data.item.dtCurrentPeriodEnd;

//     modalStore.openReceivedModal(
//       [
//         {
//           amount: planData.received,
//           type: "powerCube",
//         },
//       ],
//       "paymentReceivedList"
//     );
//   }
// };
</script>
